// import XLSX from 'xlsx';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

// function exportExcel(data, sheetName, fileName) {
function exportExcel( data, fileName = '数据表.xlsx',colsWidth=[{ wpx: 145 }, { wpx: 100 }, { wpx: 200 }, { wpx: 80 }, { wpx: 150 }, { wpx: 100 }, { wpx: 300 }, { wpx: 300 }]) {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "sheet");
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const dataBlob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
    saveAs(dataBlob, fileName);
}
function importExcel(file,callBack){
    const fileReader = new FileReader()
      fileReader.onload = (event) => {
        try {
          const { result } = event.target
          // 以二进制流方式读取得到整份excel表格对象
          const workbook = XLSX.read(result, { type: 'binary' })
          let data = [] // 存储获取到的数据
          // 遍历每张工作表进行读取（这里默认只读取第一张表）
          for (const sheet in workbook.Sheets) {
            if (workbook.Sheets.hasOwnProperty(sheet)) {
              // 利用 sheet_to_json 方法将 excel 转成 json 数据
              data = data.concat(
                XLSX.utils.sheet_to_json(workbook.Sheets[sheet]),
              )
              // break; // 如果只取第一张表，就取消注释这行
            }
          }
          callBack(data)
        } catch (e) {
          // 这里可以抛出文件类型错误不正确的相关提示
          console.log('文件类型不正确')
          return
        }
      }
      if (file !== undefined) {
        // 以二进制方式打开文件
        // fileReader.readAsBinaryString(file)
        fileReader.readAsArrayBuffer(file)
      }

}
export default {exportExcel,importExcel};